import { FreeTextKey } from '../types/FreeText';
import { wixSdkAdapter } from './wixSdkAdapter';

export const getFreeText = async () => {
  return wixSdkAdapter.getPublicData<string>(Object.values(FreeTextKey));
};
